module.exports = __webpack_public_path__ + "static/Challenge-91109760c2edf6ca40d2e92ecc0aafe0.png";